import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoadingStore } from '@/stores/loadingStore';

export function RouteLoadingIndicator({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { setRouteLoading } = useLoadingStore();

  useEffect(() => {
    // Set loading when route changes
    setRouteLoading(true);

    // Clear loading after component renders
    const timer = setTimeout(() => {
      setRouteLoading(false);
    }, 0);

    return () => {
      clearTimeout(timer);
      setRouteLoading(false);
    };
  }, [location.pathname, setRouteLoading]);

  return <>{children}</>;
}
